import get from "lodash/get";
import React from "react";
import generateAvatarSVG from "../utils/generate-avatar-svg";
import { useRillContext } from "../rill/RillReact/share/base";

function Page({ children }) {
  const { locals } = useRillContext();
  const { snapshot, activeUser, momentTZ } = locals || {};
  const user = get(snapshot, "user", {});
  const [firstName, lastName] = get(user, "name", "").split(/ +/);
  const avatarFile = get(user, "avatar.file");
  const avatarURL = avatarFile
    ? `/api/file/${avatarFile}?w=100&h=100`
    : firstName && lastName
    ? generateAvatarSVG(firstName, lastName)
    : "";

  const shareType =
    {
      "competition-history": "Competition Report",
      workout: "Workout",
    }[snapshot.type] || "Metrics";

  return (
    <div id="share-wrapper">
      <div className="head">
        <div className="container">
          <a className="logo" href="http://mystrengthbook.com/">
            <img src="/img/msb-logo-white.svg" alt="My Strength Book" />
          </a>
          {!activeUser && (
            <div className="nav">
              <a href="/login">Login</a>
              <a className="trial" href="/signup">
                Free Trial
              </a>
            </div>
          )}
        </div>
      </div>
      <div className="profile">
        <div className="container">
          {avatarURL && (
            <div className="avatar">
              <img src={avatarURL} />
            </div>
          )}
          <div className="name">{user.name}</div>
          <div className="since">
            Member since {momentTZ(user.registered).format("MMMM YYYY")}
          </div>

          <a
            className="text-button icon"
            href={`/actions/refresh?modal[type]=share&modal[snapshot]=${get(
              snapshot,
              "_id"
            )}`}
          >
            <img src="/img/svg/icon_share.svg" alt="icon" />
            Share {shareType}
          </a>
        </div>
      </div>
      {children}
      <div className="hashtags">
        <div className="container">
          #MyStrengthBook &nbsp; #TrackAnalyzeTrain
        </div>
      </div>
      <div className="social-media">
        <div className="container">
          <a href="https://www.instagram.com/MyStrengthBook" target="_blank">
            <svg viewBox="0 0 20 20">
              <path
                className="cls-1"
                d="M17.52,0.33h-15A2.15,2.15,0,0,0,.33,2.48v15a2.15,2.15,0,0,0,2.15,2.15h15a2.15,2.15,0,0,0,2.15-2.15v-15A2.15,2.15,0,0,0,17.52.33ZM10,6.33A3.67,3.67,0,1,1,6.34,10,3.67,3.67,0,0,1,10,6.33ZM17.38,16.9a0.54,0.54,0,0,1-.54.54H3.05a0.54,0.54,0,0,1-.54-0.54V8.71a0.54,0.54,0,0,1,0-.1H4.05a6.11,6.11,0,1,0,11.89,0h1.43a0.54,0.54,0,0,1,0,.1V16.9Zm0-11.61a1.07,1.07,0,0,1-1.07,1.07H14.67a1.07,1.07,0,0,1-1.07-1.07V3.61a1.07,1.07,0,0,1,1.07-1.07h1.64a1.07,1.07,0,0,1,1.07,1.07V5.28Z"
              />
            </svg>
          </a>
          <a href="https://www.facebook.com/mystrengthbook" target="_blank">
            <svg viewBox="0 0 20 20">
              <path
                className="cls-1"
                d="M11.5,19.71V10.85h3L14.92,7.4H11.5V5.19c0-1,.28-1.68,1.71-1.68H15V0.43A24.33,24.33,0,0,0,12.38.29c-2.64,0-4.44,1.61-4.44,4.56V7.4H5v3.45h3v8.86H11.5Z"
              />
            </svg>
          </a>
          <a href="https://twitter.com/MyStrengthBook" target="_blank">
            <svg viewBox="0 0 20 20">
              <path
                className="cls-1"
                d="M20.14,3.71a8.28,8.28,0,0,1-2.39.66,4.19,4.19,0,0,0,1.83-2.3,8.3,8.3,0,0,1-2.64,1A4.16,4.16,0,0,0,9.85,6.87,11.81,11.81,0,0,1,1.27,2.52,4.17,4.17,0,0,0,2.56,8.08,4.12,4.12,0,0,1,.68,7.56V7.61A4.16,4.16,0,0,0,4,11.69a4.18,4.18,0,0,1-1.88.07A4.17,4.17,0,0,0,6,14.65,8.35,8.35,0,0,1,.86,16.43a8.46,8.46,0,0,1-1-.06,11.77,11.77,0,0,0,6.38,1.87A11.75,11.75,0,0,0,18.07,6.4c0-.18,0-0.36,0-0.54A8.45,8.45,0,0,0,20.14,3.71Z"
              />
            </svg>
          </a>
          <a
            href="https://www.youtube.com/channel/UCw6AmeRWWZthv-lnzcXgBsQ"
            target="_blank"
          >
            <svg viewBox="0 0 20 20">
              <path
                className="cls-1"
                d="M19.68,6a4.29,4.29,0,0,0-.78-2,2.82,2.82,0,0,0-2-.83C14.16,3,10,3,10,3h0s-4.15,0-6.91.2a2.82,2.82,0,0,0-2,.84A4.29,4.29,0,0,0,.33,6a29.88,29.88,0,0,0-.2,3.2v1.5a29.88,29.88,0,0,0,.2,3.2,4.29,4.29,0,0,0,.78,2,3.35,3.35,0,0,0,2.15.83c1.58,0.15,6.74.2,6.74,0.2s4.15,0,6.92-.21a2.82,2.82,0,0,0,2-.84,4.29,4.29,0,0,0,.78-2,29.93,29.93,0,0,0,.2-3.2V9.24A29.93,29.93,0,0,0,19.68,6ZM8,12.56V7L13.3,9.79Z"
              />
            </svg>
          </a>
        </div>
      </div>
      <div className="foot">
        © 2016 MyStrengthBook. All rights reserved.
        <a href="http://www.mystrengthbook.com/privacy-policy" target="_blank">
          Privacy Policy
        </a>
        <a
          href="http://www.mystrengthbook.com/terms-and-conditions"
          target="_blank"
        >
          Terms of Use
        </a>
      </div>
    </div>
  );
}

export default Page;
